module.exports = __webpack_public_path__ + "media/images/extremely_likely_smiley-5ae683b374b2e061fffe9ba47afab728.svg";